export default __webpack_public_path__ + "3f5e82cc7622d1a22f9213b517b6be99.svg";